module.exports = __webpack_public_path__ + "static/media/profileCircle.49d789c6.svg";